import React from 'react';
export const TranslationContext = React.createContext();
